import { render, staticRenderFns } from "./BanksFooter.vue?vue&type=template&id=744723f0&"
import script from "./BanksFooter.vue?vue&type=script&lang=js&"
export * from "./BanksFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports